import side_nav_logo from '../../styles/images/braxo-full-logo.svg'
import { useLocation, Link } from 'react-router-dom'
import { useRef, useState } from 'react'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import BarChartIcon from '@mui/icons-material/BarChart'
import PeopleIcon from '@mui/icons-material/People'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import LanguageIcon from '@mui/icons-material/Language'
import LocalCafeIcon from '@mui/icons-material/LocalCafe'
import SettingsIcon from '@mui/icons-material/Settings'

const SideNav = () => {
  const contentEl = useRef() as React.MutableRefObject<HTMLInputElement>
  const [clicked, setClicked] = useState(-1)

  const location = useLocation()
  const pathname = location.pathname

  const role = (() => {
    try {
      const token = sessionStorage.getItem('token')
      if (!token) return null
      return JSON.parse(atob(token.split('.')[1]))?.role
    } catch {
      return null
    }
  })()

  const menuItems = [
    { label: 'Reports', icon: <BarChartIcon fontSize="small" />, path: '/reports', superAdminOnly: true },
    { label: 'Community', icon: <PeopleIcon fontSize="small" />, path: '/community' },
    { label: 'Other Revenue', icon: <TrendingUpIcon fontSize="small" />, path: '/other-revenue' },
    { label: 'Variable Expenses', icon: <ReceiptLongIcon fontSize="small" />, path: '/variable-expenses', superAdminOnly: true, },
    { label: 'Fixed Expenses', icon: <ReceiptLongIcon fontSize="small" />, path: '/fixed-expenses', superAdminOnly: true },
    {
      label: 'Finance',
      icon: <AccountBalanceWalletIcon fontSize="small" />,
      superAdminOnly: true,
      children: [
        { label: 'Accounts', path: '/running-dashboard' },
        { label: 'Transactions', path: '/transactions' },
        { label: 'Menu Transactions', path: '/menu-transactions' },
        { label: 'Transfer Between Accounts', path: '/transfers' },
      ],
    },
    {
      label: 'Website',
      icon: <LanguageIcon fontSize="small" />,
      children: [
        { label: 'Office', path: '/offices' },
        { label: 'Rentals', path: '/rentals' },
        { label: 'Testimonials', path: '/our-clients' },
        { label: 'Events', path: '/events' },
        { label: 'Q&A', path: '/questions-and-answers' },
        { label: 'Office Options', path: '/office-options' },
        { label: 'Email Feedback', path: '/feedback' },
      ],
    },
    {
      label: 'Snacks',
      icon: <LocalCafeIcon fontSize="small" />,
      children: [
        { label: 'Menu', path: '/menu' },
      ],
    },
    {
      label: 'Settings',
      icon: <SettingsIcon fontSize="small" />,
      children: [
        { label: 'Specifications', path: '/specifications' },
        { label: 'Membership Plans', path: '/membership-plans' },
      ],
    },
  ]

  const handleToggle = (id: number) => {
    setClicked(clicked === id ? -1 : id)
  }

  return (
    <div className="fixed inset-y-0 left-0 w-64 bg-white flex flex-col z-40 border-r border-gray-100">
      <div className="px-5 py-4 border-b border-gray-100 shrink-0">
        <img src={side_nav_logo} className="w-full" alt="Braxo Hub Logo" />
      </div>

      <div className="flex-1 overflow-y-auto px-3 py-3 space-y-0.5">
        {menuItems.filter(item => !item.superAdminOnly || role === 'SUPER_ADMIN').map((menuItem, id) => {
          if (!menuItem.children) {
            const isActive = pathname.startsWith(menuItem.path)
            return (
              <Link
                key={id}
                to={menuItem.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors
                  ${isActive
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}
              >
                {menuItem.icon}
                <span>{menuItem.label}</span>
              </Link>
            )
          }

          const isGroupActive = menuItem.children.some(c => pathname.startsWith(c.path))

          return (
            <div key={id}>
              <button
                onClick={() => handleToggle(id)}
                className={`w-full flex justify-between items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors
                  ${isGroupActive ? 'text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}
              >
                <div className="flex items-center gap-3">
                  {menuItem.icon}
                  <span>{menuItem.label}</span>
                </div>
                <KeyboardArrowDownOutlinedIcon
                  fontSize="small"
                  className={`transition-transform duration-200 shrink-0 ${clicked === id ? 'rotate-180' : ''}`}
                />
              </button>

              <div
                ref={contentEl}
                style={clicked === id ? { height: 'auto' } : { height: '0px' }}
                className="overflow-hidden transition-all duration-200"
              >
                <div className="pl-3 pb-1 space-y-0.5">
                  {menuItem.children.map((el, childIndex) => {
                    const isChildActive = pathname.startsWith(el.path)
                    return (
                      <Link
                        key={childIndex}
                        to={el.path}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-colors
                          ${isChildActive
                            ? 'bg-gray-100 text-gray-900 font-medium'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-800'}`}
                      >
                        <span className="w-1 h-1 rounded-full bg-current opacity-50 shrink-0" />
                        {el.label}
                      </Link>
                    )
                  })}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SideNav
